import { __decorate, __metadata, __param } from "tslib";
import _ from 'lodash';
import { inject, injectable } from 'inversify';
import dayjs from 'dayjs';
import { contentDownload } from '../@core/utils/download';
import { Symbols } from '../symbols';
let CompanyReportService = class CompanyReportService {
    constructor(exportApi, companyApi, accountApi, companyReportApi, i18n) {
        this.exportApi = exportApi;
        this.companyApi = companyApi;
        this.accountApi = accountApi;
        this.companyReportApi = companyReportApi;
        this.i18n = i18n;
        this.getCompanyInfo = this.companyApi.getCompanyInfo;
        this.getQueryCompanyProducts = this.companyApi.getQueryCompanyProducts;
        this.getAccountProducts = this.accountApi.getAccountProducts;
        this.getCompanyAccountReport = this.companyReportApi.getCompanyAccountReport;
        this.getAccountsReportTable = this.companyReportApi.getAccountsReportTable;
    }
    get Today() {
        return dayjs().format('YYYYMMDD');
    }
    companyPackages(companyInfo) {
        if (!companyInfo) {
            return [];
        }
        const { company_privileges = [], company_package_info_list = [], } = companyInfo;
        let packages = _.flatMap(company_privileges, pv => {
            return pv.packages;
        });
        packages = [...packages, ...company_package_info_list];
        packages = _.uniqBy(packages, pkg => pkg?.package_id);
        return packages;
    }
    async exportCompanyService(company_name, params) {
        const data = await this.exportApi.getExportCompany(params);
        const filename = this.i18n.t('backoffice.company.export.export_company_template', {
            company_name,
            date: this.Today,
        });
        contentDownload(filename, data);
    }
};
CompanyReportService = __decorate([
    injectable(),
    __param(0, inject(Symbols.ExportApi)),
    __param(1, inject(Symbols.CompanyApi)),
    __param(2, inject(Symbols.AccountApi)),
    __param(3, inject(Symbols.CompanyReportApi)),
    __param(4, inject(Symbols.I18n)),
    __metadata("design:paramtypes", [Object, Object, Object, Object, Object])
], CompanyReportService);
export { CompanyReportService };
